const mod = (a, b) => a % b;
export default mod;
